import { PlayerRef } from '@remotion/player';
import React, { useEffect } from 'react';
import { setSelectedItems } from '../state/actions/set-selected-items';
import { isEventTargetInputElement } from '../utils/is-event-target-input-element';
import { useTracks, useWriteContext } from '../utils/use-context';

export const SelectAllShortcut: React.FC<{
  playerRef: React.RefObject<PlayerRef | null>;
  skimFrame: number | null;
  isSkimming: boolean;
}> = () => {
  const { tracks } = useTracks();
  const { setState } = useWriteContext();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (isEventTargetInputElement(e)) {
        return;
      }

      if ((e.metaKey || e.ctrlKey) && e.key === 'a') {
        e.preventDefault();

        const allItemIds = tracks.flatMap((track) => track.items);

        setState({
          update: (state) => setSelectedItems(state, allItemIds),
          commitToUndoStack: false,
        });
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [tracks, setState]);

  return null;
};
